export const common = {
  nav: {
    home: 'Accueil',
    about: 'À Propos',
    solutions: 'Solutions',
    pricing: 'Tarifs',
    contact: 'Contact'
  },
  footer: {
    solutions: 'Solutions',
    company: 'Entreprise',
    contact: 'Contactez-Nous',
    allRightsReserved: 'Tous droits réservés',
    marketAnalysis: 'Analyse de Marché',
    leadEnablement: 'Activation de Leads',
    businessIntelligence: 'Intelligence d\'Affaires',
    strategicSupport: 'Support Stratégique',
    about: 'À Propos',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation'
  },
  contact: {
    phone: 'Téléphone',
    email: 'Email',
    address: 'Adresse'
  }
};
